module.exports = __webpack_public_path__ + "static/media/upload_media.50307b47.svg";